import { message } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { affiliateProductsApi } from '../../api/affiliate_products';
import { guestApi } from '../../api/guest';
import { setSavedProducts } from '../../features/auth/auth';
import { AffiliateProduct } from '../../interfaces/affiliate_products';
import { SavedItems } from '../../interfaces/saved_items';
import { TTUserProfile } from '../../interfaces/user';
import { RootState } from '../../rootReducer';
import NavBar from '../components/BackButton';
import { AffiliateProductDetailModal } from '../Menu/Menus/components/AffiliateProductDetailModal';
import { centsToDollars } from '../utils';
import { useAppDispatch } from '../../store';

type Props = {};

export function SavedProductsHome() {
  const products = useSelector<RootState, SavedItems[]>(
    state => state.auth.saved_products,
  );
  const profile = useSelector<RootState, TTUserProfile | null>(
    state => state.auth.userProfile,
  );
  const dispatch = useAppDispatch();
  const [fetching, setFetching] = useState(false);
  const fetchProducts = async () => {
    try {
      setFetching(true);
      const response = await guestApi.getSavedProducts(profile?.id);
      dispatch(setSavedProducts(response.data));
      setFetching(false);
    } catch (e) {
      setFetching(false);
      message.error(e?.response?.data?.detail ?? 'Unable to fetch products');
    }
  };

  const [showProduct, setShowProduct] = useState<SavedItems | null>(null);
  const [affiliateProduct, setAffiliateProduct] =
    useState<AffiliateProduct | null>(null);

  const fetchAffiliateProduct = async (product_id: number) => {
    try {
      const product = await affiliateProductsApi.getProduct(product_id);
      setAffiliateProduct(product.data);
    } catch (e) {
      message.error('Unable to fetch the product.');
    }
  };

  useEffect(() => {
    if (profile) {
      fetchProducts();
    }
  }, [profile?.id]);

  return (
    <>
      <div className="overflow-y-auto scrolling-touch min-h-screen bg-surface pb-32">
        <NavBar show_refresh={false} hide={true} />
        <div className="bg-surface px-4 py-8 md:px-32">
          <div className="text-lg font-bold text-on-surface">
            Saved Products
          </div>
          {products?.map(p => {
            return (
              <div
                onClick={async () => {
                  setShowProduct(p);
                  await fetchAffiliateProduct(p?.product_id);
                }}
                key={p?.id?.toString()}
                className="bg-surface-variant flex space-x-4 flex-row rounded-md border-outline px-2 py-2 my-2"
              >
                {p?.product_image_url && (
                  <img
                    src={p?.product_image_url}
                    className={'w-24 h-24 object-cover rounded-md'}
                  />
                )}
                <div>
                  <div className="text-base font-semibold text-on-surface-variant">
                    {p?.product_name}
                  </div>
                  {p?.product_base_price && (
                    <div className="text-base font-semibold text-on-surface-variant">
                      {centsToDollars(p?.product_base_price)}
                    </div>
                  )}

                  <div className="text-base text-on-surface-variant">
                    Saved at:{' '}
                    {moment.utc(p?.created_at)?.local()?.format('lll')}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {showProduct && affiliateProduct && (
          <AffiliateProductDetailModal
            onDone={() => {
              setShowProduct(null);
              setAffiliateProduct(null);
            }}
            product={affiliateProduct}
            display_partner_id={showProduct?.merchant_id}
          />
        )}
      </div>
    </>
  );
}
